import {
    DROPZONE_SET_QUERY,
    DROPZONE_SUBMIT_ERROR,
    DROPZONE_SEARCH,
    DROPZONE_SET_ARTICLE_LIST
} from '../Actions/DropZone.action';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    payload: {
        query: ''
    },
    showInfo: false,
    articles: [],
    errors: {},
    result: {},
};

export const dropZone = (state = defaultState, action) => {
    const { type, payload, articles } = action;
    switch (type) {
        case DROPZONE_SET_QUERY:
        case DROPZONE_SEARCH:
            return {
                ...state,
                payload: {
                    ...state.payload,
                    ...payload,
                },
                showInfo: true
            }
        case DROPZONE_SET_ARTICLE_LIST:
            return {
                ...state,
                articles: articles,
                showInfo: true
            }
        case DROPZONE_SUBMIT_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        default:
            return state;
    }
}